import React from 'react';
import Topslider from '../../Components/Homecomp/Calccomp/Topslider';
import Updcomp from '../../Components/Homecomp/Updcomp/Updcomp';
export default function Updatepge() {
  return (
    <div>
        
        <Topslider/>
        <br>
        </br><br></br><br/>
        <Updcomp/>
    </div>
  )
}
